module.exports = __webpack_public_path__ + "img/grey_closeicon.3febbdb1.svg";